import React from "react";
import { Link } from 'react-router-dom'
import { Styled } from './styled';
import { StyledScreen } from "~common/screen";
import { BlueButton } from "~/components/pages/features/components/blue-button";

const Business = () => {
  return (
    <Styled.Container>
      <Styled.Title>Бизнес-<StyledScreen.GreenText>аналитика</StyledScreen.GreenText></Styled.Title>
      <Styled.TitleTextMobile>Отчеты</Styled.TitleTextMobile>
      <Styled.Content>
          <Styled.Image src={`${process.env.PUBLIC_DIR}/images/features-page/business/report.svg`} />
        <div>
          <Styled.TitleText>Отчеты</Styled.TitleText>
          <Styled.Text>
            Расчет ключевых показателей эффективности
            <Styled.Text>в один клик:</Styled.Text>
            <Styled.List>
              <Styled.TextList>Число звонков в разбивке по типам;</Styled.TextList>
              <Styled.TextList>Длительности разговоров — абсолютные и средние значения, суммарные и отдельно по каждому сотруднику;</Styled.TextList>
              <Styled.TextList>Скорость обработки входящих;</Styled.TextList>
              <Styled.TextList>Время ожидания на линии.</Styled.TextList>
            </Styled.List>
            Список отчетов регулярно пополняется.
          </Styled.Text>
          <Styled.Btn>
            <Link to={'/features/reports'} >
              <BlueButton text={'Подробнее'} />
            </Link>
          </Styled.Btn>
        </div>
      </Styled.Content>
      <Styled.ContentBlock>
        <Styled.Block>
          <Styled.TitleTextBlock>Дашборд</Styled.TitleTextBlock>
          <Styled.Image2 src={`${process.env.PUBLIC_DIR}/images/features-page/business/dashboard.svg`} />
          <Styled.Text>Покажет число и % пропущенных звонков, сколько клиентов на линии и количество свободных сотрудников</Styled.Text>
        </Styled.Block>
        <Styled.Block2>
          <Styled.TitleTextBlock>Статистика</Styled.TitleTextBlock>
          <Styled.Image3 src={`${process.env.PUBLIC_DIR}/images/features-page/business/statistics.svg`} />
          <Styled.Text>Анализ звонков в различных срезах: номера, сотрудники, тип звонков, длительность <br /> разговоров</Styled.Text>
        </Styled.Block2>
      </Styled.ContentBlock>
    </Styled.Container>
  )
}

export default Business
